import { effect, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { AppState } from 'app/state/app.state';
import { map } from 'rxjs';
import { AccessLevel, ProductContextType } from '../models';

declare let HubSpotConversations: any;

@Injectable({
  providedIn: 'root'
})
export class HubSpotService {
  private store = inject<Store<AppState>>(Store);
  private loaded = false;

  private allowedHubspotLevels: string[] = [
    AccessLevel.ExternalCustomerAdmin,
    AccessLevel.InternalCustomerAdmin,
    AccessLevel.PlatformOwner,
    AccessLevel.SuperAdmin,
    AccessLevel.SurveyAdmin,
    AccessLevel.Admin,
  ];

  private isHandset = toSignal(this.store.select(s => s.navtreeState.isHandset));
  private productContextKey = toSignal(this.store.select(s => s.companyContext?.productContext?.key));
  private userHasHubSpotAccess = toSignal(this.store.select((s) => s.userInfo.userPermission).pipe(
    map((p) => p.isAdmin || this.hubSpotAccess(p?.accessLevels)),
  ));
  private contextEffect = effect(() => {
    const key = this.productContextKey();
    const hasAccess = this.userHasHubSpotAccess();
    if (key === ProductContextType.EX && hasAccess) {
      this.loadScript();
    } else {
      this.removeScript();
    }
  });

  private loadScript(): void {
    if (this.loaded) return;
    this.loaded = true;

    (window as any).hsConversationsSettings = { loadImmediately: true };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js-eu1.hs-scripts.com/8416921.js';
    document.head.appendChild(script);

    const onReady = () => {
      if (typeof HubSpotConversations !== 'undefined') {
        HubSpotConversations.widget.load();
      }
      HubSpotConversations.on('widgetLoaded', () => {
        if (this.isHandset()) return;
        const container = document.getElementById('hubspot-messages-iframe-container');
        container?.style.setProperty('bottom', '72px', 'important');
        container?.style.setProperty('right', '0px', 'important');
      });
    };

    if (typeof HubSpotConversations !== 'undefined') {
      onReady();
    } else {
      (window as any).hsConversationsOnReady = [onReady];
    }
  }

  private removeScript(): void {
    if (!this.loaded) return;
    if (typeof HubSpotConversations !== 'undefined') {
      HubSpotConversations.widget.remove();
    }
    document.getElementById('hs-script-loader')?.remove();
    this.loaded = false;
  }

  hubSpotAccess(accessLevels: string[]): boolean {
    return (
      accessLevels != null &&
      accessLevels.some((level) => this.allowedHubspotLevels.includes(level))
    );
  }
}


